import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Kbd({ className, ...props }: ComponentProps<'kbd'>): ReactNode {
  return (
    <kbd
      className={cn(
        'inline-flex items-center rounded border border-border bg-surface px-1 py-px text-[11px] leading-[15px] text-fg-muted',
        className,
      )}
      {...props}
    />
  )
}
